import { handleResponse, handleError, headerset } from "../apiUtils";
import { Assegnazione } from "components/main/produzione/ordiniLavoro/ordiniLavoroTypes";
import { convertToDateTime } from "../../components/common/dateUtils/convertToDateTime";

// ============================================
// BASE URL
// ============================================

const baseUrl = (ordineLavoroId: number, assegnazioneId?: number | null, azione?:string) => {
    let url = `${process.env.API_URL}/api/produzione/ordini-lavoro/${ordineLavoroId}/assegnazioni/`;

    if (assegnazioneId) {
        url += `${assegnazioneId}/`;
    }
    if (azione) {
        url += `?azione=${azione}`;
    }
    return url;
};

// ============================================
// API FUNCTIONS
// ============================================

/**
 * Save (create/update) assegnazione
 */
export function saveAssegnazione(ordineLavoroId: number, assegnazione: Assegnazione, azione?:string) {
    const assegnazioneToSave = {
        ...assegnazione,
        ordine_di_lavoro: ordineLavoroId,
        data_da: assegnazione.data_da
            ? convertToDateTime(assegnazione.data_da)?.setLocale("it").toFormat("yyyy-MM-dd")
            : null,
        data_a: assegnazione.data_a
            ? convertToDateTime(assegnazione.data_a)?.setLocale("it").toFormat("yyyy-MM-dd")
            : null,
    };

    return fetch(baseUrl(ordineLavoroId, assegnazione.id, azione), {
        method: assegnazione.id ? "PUT" : "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
        body: JSON.stringify(assegnazioneToSave),
    })
        .then(handleResponse)
        .catch(handleError);
}

/**
 * Delete assegnazione
 */
export function deleteAssegnazione(ordineLavoroId: number, assegnazioneId: number) {
    return fetch(baseUrl(ordineLavoroId, assegnazioneId), {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}